import type { FC, ReactNode } from 'react';
import type { PopoverRenderTriggerRenderProps } from '@components/Popover';
import { Popover } from '@components/Popover';
import { VisibilityReasonsList } from '@features/visibility-reasons';
import type { BlockVisibilityOutput } from '@root/@types/types';

const VARIATION_NO_CONDITIONS_COPY = 'No conditions defined for this variant';
const BLOCK_NO_CONDITIONS_COPY = 'No conditions defined for this variant';

interface VisibilityReasonsProps {
  visibilityDetails?: BlockVisibilityOutput;
  trigger: (props: PopoverRenderTriggerRenderProps) => ReactNode;
  mode?: 'block' | 'variation';
}

export const VisibilityReasons: FC<VisibilityReasonsProps> = ({ visibilityDetails, trigger, mode = 'block' }) => {
  return (
    <Popover id="block-visibility-reasons" shouldRenderInsidePortal renderTrigger={trigger}>
      <div className={'w-fit max-w-lg overflow-x-hidden px-3'}>
        {visibilityDetails ? (
          <>
            <div data-testid={visibilityDetails.info} className="text-info-600 mb-2 py-2 text-xs uppercase">
              {visibilityDetails.info} ({visibilityDetails.mode})
            </div>
            <VisibilityReasonsList visibilityDetails={visibilityDetails} className="max-h-96" />
          </>
        ) : (
          <div className="text-info-600 p-5 text-xs uppercase">
            {mode === 'block' ? BLOCK_NO_CONDITIONS_COPY : VARIATION_NO_CONDITIONS_COPY}
          </div>
        )}
      </div>
    </Popover>
  );
};
